export default __webpack_public_path__ + "static/momentjs-d1aa93f866fdc54c56dc72852b3dc683.png";